import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';

function Promo() {
    return (
        <section className="promo-featured-wrapper section-padding">
            <div className="container">
                <div className="row align-center">
                    <div className="col-xl-6 col-12 text-center">
                        <div style={{
                            width: '300px',
                            height: '300px',
                            margin: '0 auto',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '10px',
                            border: '2px dashed #ccc'
                        }}>
                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                <h2 style={{ fontSize: '72px', fontWeight: 'bold', color: '#ff6b35', margin: '0' }}>8+</h2>
                                <p style={{ fontSize: '18px', color: '#666', marginTop: '10px' }}>Ani de Experiență</p>
                            </div>
                        </div>
                        <h5 style={{ marginTop: '20px' }}>
                            Ani de Experiență cu <b>Echipă Dedicată</b>
                        </h5>
                    </div>
                    <div className="col-xl-6 col-12">
                        <div className="block-contents ml-xl-5 mt-5 mt-xl-0">
                            <span>De ce Work Express?</span>
                            <h1>Servicii de Calitate Superioară</h1>
                            <h4>
                                Work Express oferă o gamă diversă de servicii de construcții, inclusiv gleturi și finisaje, vopsitorie și tapet, placări cu gips-carton și structuri.
                            </h4>
                            <p>
                                Ne mândrim cu calitatea și profesionalismul serviciilor noastre, oferind clienților noștri rezultate de înaltă calitate. Cu muncitori calificați, servicii rapide și calitative, prețuri excelente și certificări ISO, suntem alegerea potrivită pentru proiectul tău.
                            </p>
                            <Link to="/contact" className="theme-btn">
                                Contactează-ne
                                <BsArrowRight style={{ fontSize: '20px', marginLeft: '15px' }} />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Promo;
